import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => {
        if (err instanceof ApiError && err.status >= 400 && err.status < 500) return false;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
});

/** Chiavi delle query, in un solo posto per poterle invalidare con precisione. */
export const keys = {
  auth: ['auth'] as const,
  home: ['home'] as const,
  pages: (archived = false) => ['pages', { archived }] as const,
  page: (ref: string) => ['page', ref] as const,
  summary: (id: string) => ['summary', id] as const,
  notifications: ['notifications'] as const,
  pushConfig: ['push-config'] as const,
};
